import React from "react";
import { useTranslation } from "react-i18next";
import { Item } from "../../../../components/Item";

export const QuoteCardsList = ({ data, hasAnnualRate = true }) => {
  const [t] = useTranslation();
  return (
    <div className="quote-card-list">
      {data.map(
        ({
          isin,
          title,
          maturity_date,
          price_update_date,
          annual_rate,
          price,
        }) => (
          <div className="quote-card" key={isin}>
            <Item className="quote-card__row">
              <span className="quote-card__title">{t("name")}</span>
              <span className="quote-card__text">{title}</span>
            </Item>
            <Item className="quote-card__row">
              <span className="quote-card__title">{t("isin")}</span>
              <span className="quote-card__text">{isin}</span>
            </Item>
            <Item className="quote-card__row">
              <span className="quote-card__title">{t("maturity_date")}</span>
              <span className="quote-card__text">{maturity_date}</span>
            </Item>
            <Item className="quote-card__row">
              <span className="quote-card__title">{t("value")}</span>
              <span className="quote-card__text">
                {price} {t("grn")}
              </span>
            </Item>
            {hasAnnualRate && (
              <Item className="quote-card__row">
                <span className="quote-card__title">{t("profitability")}</span>
                <span className="quote-card__text quote-card__text--highlight">
                  {annual_rate}%
                </span>
              </Item>
            )}
            {/* <Item className="quote-card__row">
              <span className="quote-card__title">{t('update_date')}</span>
              <span className="quote-card__text">
                {price_update_date ? price_update_date : '—'}
              </span>
            </Item> */}
          </div>
        )
      )}
      <style jsx global>{`
        @import "./QuoteTable.scss";
      `}</style>
    </div>
  );
};
